
import { clearAppInsights } from "./app-insight/app-insight";
import { appConfig } from "../shared/app-config";

export class LoginService {
  apiClient;
  baseUrl;
  userDetail;
  logoutInProgress = false;

  constructor(baseUrl, apiClient) {
    this.apiClient = apiClient;
    this.baseUrl = appConfig.API_URL;
  }

  async validateUser(data) {
    const url = this.baseUrl + "/admin/is-admin";
    const response = await this.apiClient.get(url);
    return response;
  }

  async sendOTP(data) {
    const url = this.baseUrl + "/getcode";
    const response = await this.apiClient.post(url, data);

    return response;
  }

  async validateOtp(data) {
    const url = this.baseUrl + "/usermanagement/login";
    const response = await this.apiClient.post(url, data);
    return response;
  }

  async getUserDetailByEmail(data, force = false) {
    if (!force && this.userDetail) {
      return this.userDetail;
    } 
    try {
      const url = `${this.baseUrl}/user/detail`;
      const response = await this.apiClient.post(url, data);
      const { profiles } = response.data;
      const hasValidProfile = profiles.some(profile => 
        profile.profile_id === "platform" || profile.profile_id === "full_access"
      );
      if (hasValidProfile) {
        this.userDetail = response; 
        return response;
      } 
      // else {
      //   window.location = appConfig.AI_HUB_URL;
      // }
    } catch (error) {
      console.error("Error fetching user details:", error);
      //throw error; 
    }
  }
  async getUserProfiles(data) {
    await this.getUserDetailByEmail(data);
    return this.userDetail?.data?.profiles;
  }

  clearLoginData() {
    this.userDetail = null;
    clearAppInsights();
  }
}
